import { axios } from '@Root/API'

export const getStatic = () => {
	return axios.get(`get/student-course-session-hesa-options`)
}
